import { useEffect, useState } from "react";
import {
  getPrivateUserProfile,
  PrivateUserProfile,
} from "../../firebase/users";

export function usePrivateUserProfile(userId: string | null) {
  const [userProfile, setUserProfile] = useState<PrivateUserProfile | null>(
    null
  );

  useEffect(() => {
    async function fetch(userId: string) {
      const userProfile = await getPrivateUserProfile(userId);
      setUserProfile(userProfile);
    }
    if (userId) fetch(userId);
    else setUserProfile(null);
  }, [userId]);

  return userProfile;
}
